export default {
  '--btn_bg_main': 'purple', // 绿色按钮填充色
  '--btn_bg_white': 'purple', // 白色按钮填充色
  '--btn_bg_main_hover': '#23c366', // 绿色按钮填充色hover态
  '--btn_bd': '#94caa9', // 绿色按钮描边颜色
  '--btn_bd2': '#cae4d4', // 白色按钮边框颜色(我的软件)

  '--menu_main_bg': '#646464',
  '--menu_bg': '#f1f8f5', // 页面内菜单绿色背景颜色
  '--menu_bg_hover': '#deece5', // 页面内菜单绿色背景颜色hover
  '--menu_bg_active': '#00bc53', // 页面内菜单选中绿色背景颜色

  '--text_main': 'purple', // 默认绿色文字
  '--text_main_hover': '#0db151', // 默认绿色文字hover
  '--text_err': '#dd3232', // 强调提示文字
  '--text_1': '#000', // 强调突出文字颜色
  '--text_2': '#333', // 文字颜色
  '--text_3': '#999', // 正文文字颜色

  '--line_1': '#eee', // 分割线颜色
  '--swiper-navigation-color': '#fff',
  '--swiper-preloader-color': '#fff',
  '--swiper-pagination-color': '#fff',
  '--swiper-theme-color': '#007aff',
  '--swiper-navigation-size': '44px',
  default: false,
};
